import React from "react";

const PasswordStrengthIndicator = ({ password }) => {
  // Define rules for password strength
  const requirements = [
    { regex: /.{8,}/, label: "At least 8 characters" },
    { regex: /[A-Z]/, label: "At least one uppercase letter" },
    { regex: /[a-z]/, label: "At least one lowercase letter" },
    { regex: /[0-9]/, label: "At least one number" },
    { regex: /[^A-Za-z0-9]/, label: "At least one special character" },
  ];

  // Calculate strength based on how many requirements are met
  const getStrength = () => {
    let strength = 0;
    requirements.forEach((item) => {
      if (item.regex.test(password)) {
        strength++;
      }
    });
    return strength;
  };

  // Determine strength level and associated color
  const strength = getStrength();
  const getStrengthText = () => {
    if (!password) return "";
    if (strength < 2) return "Weak";
    if (strength < 4) return "Moderate";
    return "Strong";
  };

  const getStrengthColor = () => {
    if (!password) return "bg-gray-300";
    if (strength < 2) return "bg-red-500";
    if (strength < 4) return "bg-yellow-500";
    return "bg-green-500";
  };

  return (
    <div className="mt-2 mb-1">
      {/* Progress bar */}
      <div className="w-full h-1 bg-gray-300 rounded-full overflow-hidden">
        <div
          className={`h-full ${getStrengthColor()} transition-all duration-300`}
          style={{
            width: `${password ? (strength / requirements.length) * 100 : 0}%`,
          }}
        ></div>
      </div>

      {/* Strength text */}
      {password && (
        <div className="flex justify-between mt-1">
          <p className="text-xs text-gray-200">{getStrengthText()} password</p>
          <p className="text-xs text-gray-200">
            {strength}/{requirements.length} requirements met
          </p>
        </div>
      )}

      {/* Requirements list */}
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-y-1 gap-x-4">
        {requirements.map((requirement, index) => (
          <div key={index} className="flex items-center">
            <div
              className={`w-2 h-2 rounded-full mr-2 ${
                !password
                  ? "bg-gray-400"
                  : requirement.regex.test(password)
                  ? "bg-green-500"
                  : "bg-red-500"
              }`}
            ></div>
            <p className="text-xs text-gray-200">{requirement.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;
